<template>
  <BaseModal
    :title="$t('message.pages.discardChangesModal.title')"
    hookSufix="HasChanges"
    modalWidth="486px"
    minHeight="226px"
    :disableDefaultPadding="true"
    :onCloseHook="handlePostCloseAction"
    :persistent="true"
    :bordered="true"
    :borderedToolbar="false"
  >
    <template #content>
      <v-container class="px-6 pt-2 pb-6">
        <span class="text-subtitle-2 neutral-40--text font-weight-regular">{{
          $t('message.pages.discardChangesModal.content')
        }}</span>
      </v-container>
    </template>
    <template #card-actions>
      <v-container class="pa-6 d-flex justify-end card-actions">
        <base-btn type="tertiary" @click="keep">
          {{ $t('message.pages.discardChangesModal.actionBtns.keep') }}
        </base-btn>
        <base-btn class="ml-2" @click="discard">
          {{ $t('message.pages.discardChangesModal.actionBtns.discard') }}
        </base-btn>
      </v-container>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue'
export default {
  name: 'hasChangesModal',
  components: {
    BaseModal,
  },
  data: () => ({
    shouldClose: false,
  }),
  beforeDestroy() {
    this.shouldClose = false
  },
  methods: {
    keep() {
      this.$root.$emit('closeHasChanges')
    },
    discard() {
      this.shouldClose = true
      this.$root.$emit('closeHasChanges')
    },
    handlePostCloseAction() {
      if (this.shouldClose) {
        this.$emit('discard')
        this.shouldClose = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card-actions {
  border-top: 1px solid varFigma(neutral-95-lightest);
}
</style>
